<template>
    <div v-html="term.TermContent">
    </div>
</template>
<script>
    import api from "../api";
    export default {
        props: ['id','SourceGoodsNo','HuoZhu','CreateTime',
        'Description',
        'ChuFaDi','ChuFaDiAddr','DaoDaDi','DaoDaDiAddr','ChuFaRiQi',
        'DaoDaRiQi','GongLiShu','BaoJiaLeiXingName'
        ],
        data() {
          return {
            term: {}
          }
        },
        methods: {
            loadItem() {
                let _this = this
                api.getCondition({
                    id: _this.id,
                    tableName: "term"
                }).then(res => {
                    if (res.data.Succeed) {
                        _this.term = res.data.Data.Data
                       _this.term.TermContent= _this.term.TermContent.replace('变货主名称量',_this.HuoZhu)
                       .replace('变货源号量',_this.SourceGoodsNo)
                       .replace('变货主确认平台报价日期量',_this.CreateTime)

                       .replace('变货物描述量',_this.Description)
                       .replace('变出发地详细地址量',_this.ChuFaDi+_this.ChuFaDiAddr)
                       .replace('变目的地详细地址量',_this.DaoDaDi+_this.DaoDaDiAddr)
                       .replace('变预计起运日期量',_this.ChuFaRiQi)
                       .replace('变预计到达日期量',_this.DaoDaRiQi)
                       .replace('变行驶里程量',_this.GongLiShu==null?'暂无':_this.GongLiShu)
                       .replace('变报价方式量',_this.BaoJiaLeiXingName)
                       .replace('变货主名称量',_this.HuoZhu)
                    }
                })
            }
        },
        mounted() {
            this.loadItem()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/condition.vue